import referralsPreviewImg from 'shared/assets/images/referrals/referrals_preview.png'
import { EmptyState, Typography } from 'shared/ui'
import { LINK_REFERRALS_HELP_GUIDE } from 'shared/constants/links'
import { getCDNAssetURL } from 'shared/lib'
import { ReferralsActions } from 'pages/settings/pages/referrals/pages/ReferralsView/ui/ReferralsActions/ReferralsActions'
import styles from './styles.module.scss'

export const ReferralsViewPage = () => {
  return (
    <>
      <EmptyState
        title={
          <span className={styles.title}>
            <a
              href={LINK_REFERRALS_HELP_GUIDE}
              target='_blank'
              rel='noreferrer'
              className={styles.previewImageContainer}
            >
              <img alt='Referrals preview' src={getCDNAssetURL(referralsPreviewImg)} />
            </a>
            <Typography variant={'heading-lg'} ariaLabel={'ReferralsTitle'}>
              Refer & Earn 15% recurring
            </Typography>
          </span>
        }
        text='Join the Salesmsg Partner Program and earn 15% recurring revenue on every customer you refer.'
        actions={<ReferralsActions />}
        typographyProps={{
          variant: 'body-lg-regular',
          ariaLabel: 'ReferralsText',
          className: styles.subTitleText,
        }}
        boxProps={{
          gap: '20px',
          width: 'unset',
          height: '100%',
        }}
        noIcon
      />
    </>
  )
}
